import React from "react";
import { Modal, Button } from 'react-bootstrap';
import FilterSlider from "./FilterSlider";
import { FILTER_HOME } from "../../../constants/Constants";

class FilterModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            step: 1,
            filter: [],
          };
    }
    handleClose = () => {
        this.setState({
            show: false
        })
        this.props.handleSubmit(this.state.filter);
    }
    handleShow = () => {
        this.setState({
            show: true
        })
    }

    handleChange = (name, newValue) => {
        const newFilter = {name: name, value : newValue};
        //console.log("***************" + name + newValue)
        if(name === 'runner.metadata.backOdds' && newValue[0] > 50){
            this.setState({
                step: 10
            })
            
        }
        if(name === 'runner.metadata.backOdds' && newValue[0] < 50){
            this.setState({
                step: 1
            })
            
        }
        const oldFilter = this.state.filter;
        let updatedFilter = [];
        oldFilter.forEach(function (item) {
                if (item.name != name) {
                    updatedFilter.push(item);
                }
            });

            updatedFilter.push(newFilter);

        this.setState({
            filter: updatedFilter
        })
       
    }
    isEmptyFilter = () =>{
        //console.log("**vivek:isEmptyFilter***" + JSON.stringify(this.state.filter));
        return Object.values(this.state.filter).filter(x => x != null && x != 'undefined' && x != '').length  === 0 ;
    }

    valuetext = (value) => {
        return `${value}°C`;
      }

    getCurrentValue = (filterColumn) => {
        const fieldId = filterColumn.jsonFieldId;
        const defaultMin =  filterColumn.defaultMin;
        const defaultMax = filterColumn.defaultMax;
        const previousBalue = this.state.filter.filter((aFilter) =>aFilter.name === fieldId);
        return previousBalue && previousBalue.length == 1 ? previousBalue[0].value : [defaultMin, defaultMax];
    }

    render() {
        const isEmptyFilter = this.isEmptyFilter();
        const filterColumns = []
        for(let value in FILTER_HOME) filterColumns.push(FILTER_HOME[value])
        let allFilters = filterColumns.map(filterColumn => {
           return  <FilterSlider onChange={this.handleChange} highLow={this.getCurrentValue(filterColumn)} step={this.state.step} min={filterColumn.min} max={filterColumn.max} name={filterColumn.jsonFieldId} 
           title={filterColumn.title} />
        })

      return (
                <>
                   { isEmptyFilter  ? 
                        <img 
                        src="https://icons.iconarchive.com/icons/iconsmind/outline/256/Filter-2-icon.png"
                        alt="new"
                        onClick={this.handleShow}
                        style={{width: "29px", height: "34px", "margin-top": "9px", "margin-left": "2px","margin-right": "2px"}}
                        />
                        :
                        <img 
                        src="https://image.flaticon.com/icons/png/512/57/57164.png"
                        alt="new"
                        onClick={this.handleShow}
                        style={{width: "29px", height: "34px", "margin-top": "9px", "margin-left": "2px","margin-right": "2px"}}
                        />
                   }
                
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                    <Modal.Title>Filter</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {allFilters}
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleClose}>Close</Button>
                    <Button variant="primary" onClick={this.handleClose}>Apply</Button>
                    </Modal.Footer>
                </Modal>
                </>
      )
    }
  }

export default FilterModal;
